import apiClient from '@/utils/httpClient';
import { ProfitAndLoss, PLTransaction, TransactionLineItemDetail } from '@/interfaces/profitAndLoss.interface';
import { KpiDateRange } from './kpi.service';

/**
 * Fetch the consolidated Profit & Loss statement — summed across every connected
 * QuickBooks entity — with a monthly breakdown per line.
 */
export function fetchProfitAndLoss(range: KpiDateRange): Promise<ProfitAndLoss> {
  return apiClient.get<ProfitAndLoss>('/kpi/profit-loss', range);
}

/**
 * Fetch the transaction-level detail behind a single P&L line (across every connected entity).
 * The caller groups the flat result by vendor/payee, then by month, for the drill-down UI.
 */
export function fetchProfitAndLossLineItems(range: KpiDateRange, lineName: string): Promise<PLTransaction[]> {
  return apiClient.get<PLTransaction[]>('/kpi/profit-loss/line-items', { ...range, lineName });
}

/** Fetch full line-item detail for a single invoice or bill, for the drill-down-within-drill-down view. */
export function fetchTransactionLineItems(
  organizationId: string,
  txnId: string,
  txnType: 'Invoice' | 'Bill',
): Promise<TransactionLineItemDetail> {
  return apiClient.get<TransactionLineItemDetail>('/kpi/profit-loss/transaction-detail', {
    organizationId,
    txnId,
    txnType,
  });
}
